<script lang="ts" setup>
  import type { PropType } from 'vue';
  import type { SaleOfferMessage } from '@storefront/storefront';

  defineProps({
    message: { type: Object as PropType<SaleOfferMessage>, required: true },
  });
</script>
<template>
  <article class="message">
    <div class="message__wrapper">
      <div class="message__avatar">
        <SfAvatar :avatar="message.avatar" :name="message.name || $t('SHOP.COMMON.LABEL.CHAT_USER_UNKNOWN')" />
      </div>
      <div class="message__container">
        <header class="message__header">
          <div class="message__id">
            {{ '#' + message.id }}
          </div>
          <h3 class="message__author">
            {{ message.name || $t('SHOP.COMMON.LABEL.USER_DELETED') }}
          </h3>
          <p class="message__date">
            {{ $t('SHOP.COMMON.LABEL.CHAT_MESSAGE_SENT_AT') }}
            <SfDateTime :value="message.createdAt" time />
          </p>
        </header>
        <div class="message__content" v-html="message.message" />
      </div>
    </div>
  </article>
</template>
<style lang="scss" scoped>
  .message {
    background: var(--secondary-background);
    border-radius: var(--border-radius);
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 0.5rem;

    &__wrapper {
      display: flex;
      gap: 1rem;
      align-items: flex-start;
      width: 100%;
    }

    &__avatar {
      flex: 0 0;
      width: 3rem;

      --sf-avatar-border: var(--secondary-border-hover);
      --sf-avatar-background: var(--secondary-background-hover);
      --sf-avatar-color: var(--secondary-foreground-hover);
    }

    &__container {
      width: 100%;
    }

    &__header {
      position: relative;
      border-bottom: 1px solid var(--secondary-border-hover);
      padding-bottom: 0.25rem;
    }

    &__id {
      top: 0;
      right: 0;
      position: absolute;
      font-family: var(--font-family-mono);
      font-size: 0.625rem;
      color: var(--secondary-color);
    }

    &__content {
      font-size: 0.875rem;
    }

    &__author {
      font-weight: var(--font-weight-bold);
      font-size: 1rem;
    }

    &__date {
      color: var(--secondary-color);
      font-size: 0.625rem;
    }
  }
</style>
